import { observer } from 'mobx-react-lite'
import React, { FC, useEffect } from 'react'
import { LoadingIndicator } from '../../../../Supplier/Settlements/LoadingIndicator'
import { BtSelect } from '@linqpal/components/src/ui'
import { Spacer } from '../../../../../ui/atoms'
import { AddLink } from '../../../../../ui/atoms/AddLink'
import RootStore from '../../../../../store/RootStore'
import { PAYMENT_METHOD_TYPE } from '@linqpal/models/src/dictionaries'
import { useTranslation } from 'react-i18next'
import { AddNewCreditCardFlow } from '../../../../IntegrationPayment/InvoiceDetails/flows/AddNewCreditCardFlow'

interface IProps {
  cardAccountId: string
  onChange: (cardAccountId: string) => void
}

interface IOption {
  id: string
  name: string
}

export const DownPaymentCardOptions: FC<IProps> = observer(
  ({ cardAccountId, onChange }) => {
    const { t } = useTranslation('global')

    const [showAddCardFlow, setShowAddCardFlow] = React.useState(false)

    const { paymentMethods, loading } =
      RootStore.screensStore?.paymentMethodsStore

    const cardAccounts = paymentMethods?.filter(
      (m) => m.paymentMethodType === PAYMENT_METHOD_TYPE.CARD,
    )

    useEffect(() => {
      if (!cardAccountId && cardAccounts?.length) {
        // force select first card
        onChange(cardAccounts[0].id)
      }
    }, [cardAccounts, cardAccountId, onChange])

    const handleCardAdded = ({ cardId }: { cardId: string }) => {
      onChange(cardId)
      setShowAddCardFlow(false)
    }

    if (loading && !showAddCardFlow) return <LoadingIndicator />

    return (
      <>
        <BtSelect
          value={cardAccountId}
          onChange={(option: IOption) => onChange(option.id)}
          options={cardAccounts.map((m) => ({
            id: m.id,
            name: `${m.name} ${m.accountNumber}`,
          }))}
          disabled={loading || showAddCardFlow}
          testID={'down-payment-modal-cards-select'}
        />
        <Spacer height={10} />

        <AddLink
          label={t('DownPaymentModal.addNewCard')}
          onPress={() => setShowAddCardFlow(true)}
          testID="down-payment-modal-add-new-card"
        />

        {showAddCardFlow && (
          <AddNewCreditCardFlow
            onClose={() => setShowAddCardFlow(false)}
            onSuccess={handleCardAdded}
            invoiceId={''}
          />
        )}
      </>
    )
  },
)
